import type { UseFetchOptions } from '#app'
import type { NitroFetchOptions, NitroFetchRequest } from 'nitropack';
import qs from "qs";
import dayjs from "dayjs";

type SearchParameters = {
  [key: string | number]: any
};

type ParameterOptions = {
  filters?: SearchParameters,
  params?: SearchParameters,
  /**
   * The Time To Live (TTL) for cached data, which is usually measured in seconds, 
   * determines how long the data can remain in the cache before it is discarded 
   * and replaced with fresh data.
   * A `null` or `undefined` return value will trigger a fetch.
   */
  ttl?: number,
};

export function $getApi<T>(
  url: string | (() => string),
  parameters?: ParameterOptions,
  options: UseFetchOptions<T> = {}
) {
  let newUrl = url

  if (parameters && typeof url === 'string') {
    newUrl +=
      "?" +
      qs.stringify(
        {
          filters: parameters.filters,
          ...parameters.params 
        },
        { encode: false }
      );
  }
  
  // if (options?.params && typeof url === 'string' && !parameters) {
  //   newUrl +=
  //     "?" +
  //     qs.stringify(
  //       options.params,
  //       { encode: false }
  //     );

  //   options.params = undefined
  // }

  if (parameters?.ttl) {
    options.transform = function (input) {
        return {
        ...input,
        fetched_at: new Date()
      }
    }

    options.getCachedData = function (key, nuxtApp): any {
      const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      // If data is not fetched yet
      if (!data) {
        // Fetch the first time
        return
      }
  
      // Is the data too old?
      if (dayjs().isAfter(dayjs(data.fetched_at).add(Number(parameters.ttl), 'seconds'))) {
        // Refetch the data
        return
      }
  
      return data
    }
  }

  return useFetch(newUrl, {
    watch: false,
    key: newUrl.toString(),
    ...options,
    $fetch: useNuxtApp().$api,
  })
}

export function $postApi<T = any, R extends NitroFetchRequest = string & {}>(path: string, options?: NitroFetchOptions<R>) {
  return useNuxtApp().$api<T>(path,
    {
      ...options,
      method: 'post',
    })
}

export function $putApi<T = any, R extends NitroFetchRequest = string & {}>(path: string, options?: NitroFetchOptions<R>) {
  return useNuxtApp().$api<T>(path,
    {
      ...options,
      method: 'put',
    })
}

export function $deleteApi<T = any, R extends NitroFetchRequest = string & {}>(path: string, options?: NitroFetchOptions<R>) {
  return useNuxtApp().$api<T>(path,
    {
      ...options,
      method: 'delete',
    })
}

export function $api<T = any, R extends NitroFetchRequest = string & {}>(path: string, options?: NitroFetchOptions<R>) {
  let newUrl = path

  if (options?.params) {
    newUrl +=
      "?" +
      qs.stringify(
        options.params,
        { encode: false }
      );

      options.params = undefined  
  }

  return useNuxtApp().$api<T>(newUrl, options)
}